/** @format */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-feedback-thank-you',
    templateUrl: './feedback-thank-you.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FeedbackThankYouComponent {
    static readonly downgrade: ComponentDowngradeMappings = {
        moduleName: 'sisComponents.feedback.thankYou',
        directiveName: 'sisFeedbackThankYou',
    };

    @Input() homeState: string;

    constructor(private readonly stateService: StateService) {}

    goToFrontPage() {
        this.stateService.go(this.homeState);
    }
}
